'use strict';

(function () {
  'use strict';

  angular.module('msTracker').controller('EditTrackerListModalCtrl', EditTrackerListModalCtrl);

  EditTrackerListModalCtrl.$inject = ['$log', 'trackers', 'allMoods', 'close', 'moodTrackerSvc'];

  function EditTrackerListModalCtrl($log, trackers, allMoods, close, moodTrackerSvc) {
    var vm = this;
    vm.title = 'EditTrackerListModalCtrl';
    activate();

    ////////////////

    function activate() {
      $log.debug(vm.title + ' control activate');

      vm.currentTrackers = trackers;
      vm.allMoods = allMoods;
      vm.isSubscribed = function (trackerId) {
        return _.some(vm.currentTrackers, { id: trackerId });
      };
      vm.isRequired = function (trackerId) {
        return _.some(vm.allMoods, { id: trackerId, isRequired: true });
      };
      vm.trackerLimitReached = function () {
        return vm.currentTrackers.length >= 6;
      };
      vm.toggleTracker = function (trackerId) {
        return vm.isSubscribed(trackerId) ? _removeTracker(trackerId) : _addTracker(trackerId);
      };
      // 200ms pause to let ngAnimate hide the modal.
      // Return the list of currently tracked moods.
      vm.closeModal = function () {
        return close(vm.currentTrackers, 200);
      };
    }

    function _addTracker(trackerId) {
      if (vm.trackerLimitReached()) {
        $log.debug('Too many Trackers. Limit has been reached.');
        return;
      }
      moodTrackerSvc.addTrackedMood(trackerId).then(function () {
        $log.debug('Tracker Added', trackerId);
        vm.currentTrackers.push(_.find(vm.allMoods, { id: trackerId }));
      });
    }

    function _removeTracker(removedTrackerId) {
      if (vm.isRequired(removedTrackerId)) {
        $log.debug('This Tracker is required and cannot be removed.');
        return;
      }
      // http request happens here. When it is done (and it succeeds), close the modal.
      moodTrackerSvc.deleteTrackedMood(removedTrackerId).then(function () {
        $log.debug('Tracker Deleted', removedTrackerId);
        _.remove(vm.currentTrackers, { id: removedTrackerId });
      });
    }
  }
})();